const Layout = ({ children }) => {
  return <main className="layout">{children}</main>;
};

export default Layout;
